module.exports = __webpack_public_path__ + "static/media/logo_lvn.80bb2940.svg";